import { Link } from 'react-router-dom';

export default function VenuesList() {
  const venues = [
    {
      name: 'TOKYO LIVE HOUSE SHIBUYA',
      area: '渋谷区',
      description: '渋谷道玄坂に位置する収容300名のライブハウス。最新音響設備とバーを併設し、ジャンルを問わず幅広い公演に対応。駅徒歩3分のアクセスの良さも魅力です。',
      capacity: '300名',
      icon: 'ri-building-2-line',
    },
    {
      name: 'SHINJUKU MUSIC CLUB',
      area: '新宿区',
      description: '新宿歌舞伎町エリアの収容250名の音楽クラブ。プロ仕様の照明設備とリハーサル室を完備。深夜営業にも対応し、多様な公演スタイルを受け入れています。',
      capacity: '250名',
      icon: 'ri-music-2-line',
    },
    {
      name: 'ROPPONGI SOUND STAGE',
      area: '港区',
      description: '六本木の大型ステージを備えた収容400名の会場。VIPラウンジと駐車場を完備し、大規模イベントやプレミアム公演に最適な環境を提供しています。',
      capacity: '400名',
      icon: 'ri-surround-sound-line',
    },
    {
      name: 'IKEBUKURO LIVE SPOT',
      area: '豊島区',
      description: '池袋西口エリアの収容200名のアットホームな会場。カフェ併設で初心者アーティストも歓迎。地域密着型のイベントを数多く開催しています。',
      capacity: '200名',
      icon: 'ri-store-2-line',
    },
    {
      name: 'HARAJUKU MUSIC BOX',
      area: '渋谷区',
      description: '原宿・神宮前に位置する収容180名のスタイリッシュな会場。若手アーティスト支援に力を入れ、レコーディング設備とカフェバーを併設しています。',
      capacity: '180名',
      icon: 'ri-disc-line',
    },
    {
      name: 'AKIHABARA SOUND HALL',
      area: '千代田区',
      description: '秋葉原の収容350名の多目的ホール。最新の配信設備を備え、オンライン・オフライン両対応。楽器レンタルサービスも充実しています。',
      capacity: '350名',
      icon: 'ri-headphone-line',
    },
  ];

  return (
    <section id="venues-list" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-gray-500 tracking-widest uppercase mb-3">Venues</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">参加会場一覧</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            東京支部に加盟するライブハウスの一覧です。各会場が独自の特色を活かし、地域の音楽シーンを支えています。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {venues.map((venue, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow cursor-pointer group"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-900 text-white rounded-lg flex-shrink-0 group-hover:bg-gray-800 transition-colors">
                  <i className={`${venue.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="text-base font-bold text-gray-900 leading-tight">{venue.name}</h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-gray-500">{venue.area}</span>
                    <span className="text-gray-300">|</span>
                    <span className="text-xs text-gray-500">収容 {venue.capacity}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">{venue.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 flex flex-col items-center gap-3">
          <Link
            to="/venues-list"
            className="inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-3 rounded-md text-sm font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            参加会場一覧を見る
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/venues-detail"
            className="inline-flex items-center gap-2 text-gray-700 text-sm font-medium hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            会場一覧（詳細）を見る
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
